import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { t } from '../../../../services/i18nService';

import idVerificationService from '../../../../services/idverification/IdVerificationService';

import PreCheckAction from '../preChecks/PreCheckAction';
import IdVerificationStart from './IdVerificationStart';
import SimilarityCheckFailed from './SimilarityCheckFailed';
import SimilarityCheckPending from './SimilarityCheckPending';

class PureTestComponentIdVerification extends React.PureComponent {
    static propTypes = {
        completed: PropTypes.bool.isRequired,
        current: PropTypes.bool.isRequired,
        failed: PropTypes.bool.isRequired,
        isSimilarityCheckPending: PropTypes.bool.isRequired,
        title: PropTypes.string.isRequired,
    };

    render() {
        const {
            completed,
            current,
            failed,
            isSimilarityCheckPending: isSimilarityCheckPendingProp,
            title,
        } = this.props;

        let content = <IdVerificationStart />;

        if (failed) {
            content = <SimilarityCheckFailed />;
        } else if (isSimilarityCheckPendingProp) {
            content = <SimilarityCheckPending />;
        }

        return (
            <PreCheckAction
                current={current}
                completed={completed}
                failed={failed}
                title={title}
            >
                {content}
            </PreCheckAction>
        );
    }
}

function mapStateToProps(state) {
    const { idverification } = state;

    return {
        completed: idVerificationService.isIdVerificationComplete(idverification),
        current: idVerificationService.isCurrent(),
        failed: idVerificationService.isSimilarityCheckFailed(idverification),
        isSimilarityCheckPending: idVerificationService.isSimilarityCheckPending(idverification),
        title: t('idVerification.overview.title'),
    };
}

const TestComponentIdVerification = connect(mapStateToProps)(PureTestComponentIdVerification);

export default TestComponentIdVerification;
export { PureTestComponentIdVerification };
